var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7.5C3.22386 7.5 3 7.72386 3 8C3 8.27614 3.22386 8.5 3.5 8.5H4C4.27614 8.5 4.5 8.27614 4.5 8C4.5 7.72386 4.27614 7.5 4 7.5H3.5Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.5C5.72386 7.5 5.5 7.72386 5.5 8C5.5 8.27614 5.72386 8.5 6 8.5H8C8.27614 8.5 8.5 8.27614 8.5 8C8.5 7.72386 8.27614 7.5 8 7.5H6Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 3C0.5 2.17157 1.17157 1.5 2 1.5H11C11.8284 1.5 12.5 2.17157 12.5 3V9C12.5 9.82843 11.8284 10.5 11 10.5H2C1.17157 10.5 0.5 9.82843 0.5 9V3ZM2 2.5C1.72386 2.5 1.5 2.72386 1.5 3V4H11.5V3C11.5 2.72386 11.2761 2.5 11 2.5H2ZM11.5 5H1.5V9C1.5 9.27614 1.72386 9.5 2 9.5H11C11.2761 9.5 11.5 9.27614 11.5 9V5Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.f62ee00968e3b05ac844b30abf19df76.svg";
export { ForwardRef as ReactComponent };